<template>
  <div>
    <v-card
      flat
      :style="{
        'padding-top':
          $vuetify.breakpoint.name == 'xs'
            ? '10px'
            : $vuetify.breakpoint.name == 'sm'
            ? '150px'
            : $vuetify.breakpoint.name == 'md'
            ? '150px'
            : $vuetify.breakpoint.name == 'lg'
            ? '150px'
            : '150px',
      }"
    >
      <v-carousel
        v-model="slideNo"
        continuous
        cycle
        :interval="slideInterval"
        show-arrows-on-hover
        hide-delimiter-background
        delimiter-icon="mdi-minus"
        :height="sliderHeight"
      >
        <v-carousel-item v-for="(item, i) in imageArray" :key="i">
          <v-card flat>
            <v-img
              :lazy-src="item.img"
              :src="item.img"
              width="100%"
              :alt="item.img"
              eager
            >
              <!-- <template v-slot:placeholder> <ImageLoader /> </template
              > -->
            </v-img>
          </v-card>
          <!-- <v-card flat class="hidden-sm-and-up">
              <v-img
                :lazy-src="item.img"
                :src="item.img"
                width="100%"
                contain
                :alt="item.img"
                eager
                ><template v-slot:placeholder>
                  <ImageLoader /> </template
              ></v-img>
            </v-card> -->
        </v-carousel-item>
      </v-carousel>
    </v-card>
  </div>
</template>
<script>
// import axios from "axios";
export default {
  //   props: ["storage", "category"],
  data: () => ({
    model: 0,
    tab: 0,
    fab: true,
    slideNo: 0,
    slideInterval: 3000,
    imageArray: [
      { img: require("./../../assets/banner.jpg") },
      { img: require("./../../assets/slider-2.jpg") },
      { img: require("./../../assets/slid1.jpg") },
    ],
  }),
  computed: {
    sliderHeight() {
      var height = "300px";
      if (this.$vuetify.breakpoint.xl) height = "600px";
      if (this.$vuetify.breakpoint.lg) height = "500px";
      if (this.$vuetify.breakpoint.md) height = "400px";
      if (this.$vuetify.breakpoint.sm) height = "300px";
      if (this.$vuetify.breakpoint.xs) height = "150px";
      return height;
    },
  },
  //   beforeMount() {
  //     this.tabItems[0].page = this.category;
  //     this.getLearnAboutTheReserve();
  //     this.getGetInvolved();
  //   },
  //   methods: {
  //     getLearnAboutTheReserve() {
  //       this.appLoading = true;
  //       axios({
  //         method: "GET",
  //         url: "/static/learnaboutthereserve/get",
  //       })
  //         .then((response) => {
  //           this.appLoading = false;
  //           if (response.data.status) {
  //             this.tabItems[1].page = response.data.data;
  //           } else {
  //             this.msg = response.data.msg;
  //             this.showSnackBar = true;
  //           }
  //         })
  //         .catch((err) => {
  //           this.appLoading = false;
  //           console.log(err);
  //           this.ServerError = true;
  //         });
  //     },
  //     getGetInvolved() {
  //       this.appLoading = true;
  //       axios({
  //         method: "GET",
  //         url: "/static/getinvolved/get",
  //       })
  //         .then((response) => {
  //           this.appLoading = false;
  //           if (response.data.status) {
  //             this.tabItems[2].page = response.data.data;
  //           } else {
  //             this.msg = response.data.msg;
  //             this.showSnackBar = true;
  //           }
  //         })
  //         .catch((err) => {
  //           this.appLoading = false;
  //           console.log(err);
  //           this.ServerError = true;
  //         });
  //     },
  //   },
};
</script>
<style>
.theme--light.v-tabs-items {
  background-color: transparent !important;
  background: transparent linear-gradient(180deg, #000000 0%, #54545450 100%) 0%
    0% no-repeat padding-box;
  box-shadow: 0px 3px 6px #00000029;
  opacity: 1;
}
</style>
